import * as React from 'react';
import { InputProps, InputType } from './Input.types';

import './input.css';

export const Input = ({
    type,
    value,
    min,
    name,
    onChange,
    onBlur,
    onFocus,
    onKeyUp,
    label,
    labelHidden,
    id,
    className,
    validation,
}: InputProps): JSX.Element => {
    const isValid = 
        (validation === undefined || validation.length === 0) ||
        (validation.filter(v => v.match).length === 0);
    return (
        <div className={`
            input
            ${labelHidden ? 'input--label-hidden' : null}
            ${!isValid ? 'input--error' : null}
        `}>
            <label htmlFor={id}>
                {label}
            </label>
            <input
                id={id}
                name={name}
                className={className}
                value={value}
                min={min}
                type={type ? type : InputType.Text}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onChange && onChange(e);
                }}
                onBlur={(e: any) => onBlur && onBlur(e)}
                onFocus={(e: any) => onFocus && onFocus(e)}
                onKeyUp={(e: any) => {
                    onKeyUp && onKeyUp(e);
                }}
            />
            {validation && validation.map(v => (
                v.match ? (
                    <div className="validation-message">{v.message}</div>
                ) : null
            ))}
        </div>
    );
}
